var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quantityString == 1)?_c('span',[_vm._v(_vm._s(_vm.quantityProduct)+"+")]):_c('span',[_vm._v(_vm._s(_vm.quantityProduct))])}
var staticRenderFns = []

export { render, staticRenderFns }